import { AbstractControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DpnItemForm } from './data-protection-notice.model';

export function countriesRequiredIfNotDefault(control: AbstractControl): ValidationErrors {
  const dpnItemModel = control.parent as FormGroup<DpnItemForm>;
  if (dpnItemModel) {
    const isDefaultDpnControl = dpnItemModel.get('defaultDpn');
    const countriesControl = dpnItemModel.get('countries');
    const isDefaultDpn = isDefaultDpnControl?.value;

    if (isDefaultDpn) {
      countriesControl.clearValidators();
    } else {
      countriesControl.setValidators([Validators.required]);
    }
    countriesControl.updateValueAndValidity({
      onlySelf: true,
    });
  }

  return null;
}
